<form-workflow
  [form]="rsf"
  [sectionNumber]="2"
  [amendmentSectionNumbers]="[8]"
  [service]="service"
  [disabled]="disabled"
  [minorAmendmentIDs]="minorAmendmentIDs"
></form-workflow>
